import React from "react";
import { withStyles } from "@material-ui/styles";
import { map, get } from "lodash";

import Box from "@material-ui/core/Box";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";

import CustomButton from "./CustomButton";

import colors from "../../assets/style/colors";

const styles = {
  menuItem: {
    padding: "15px 30px",
    fontSize: "1em",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  imgIcon: {
    height: "20px",
    maxWidth: "35px",
  },
};

const DropdownButton = (props) => {
  const { classes, buttonProps, title, options, callback } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <Box style={props.style}>
      <Box onClick={(event) => setAnchorEl(event.currentTarget)}>
        {props.triggerNode ? (
          props.triggerNode
        ) : (
          <CustomButton
            {...buttonProps}
            //onMouseEnter={event => setAnchorEl(event.currentTarget)}
            style={{ margin: 0 }}
          >
            {title || ""}
          </CustomButton>
        )}
      </Box>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        // MenuListProps={{ onMouseLeave: () => setAnchorEl(null) }}
        anchorOrigin={
          props.anchorOrigin || { vertical: "bottom", horizontal: "right" }
        }
        getContentAnchorEl={null}
      >
        {map(options, (opt, index) => (
          <MenuItem
            key={index}
            classes={{ root: classes.menuItem }}
            alignItems="center"
            onClick={() => {
              setAnchorEl(null);
              callback(opt);
            }}
          >
            {get(opt, ["startIcon"]) && (
              <ListItemIcon
                classes={{ root: classes.itemIcon }}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img
                  src={get(opt, ["startIcon"])}
                  alt="option_icon"
                  className={classes.imgIcon}
                />
              </ListItemIcon>
            )}
            {get(opt, ["element"])}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default withStyles(styles)(DropdownButton);
